import Roles from "../../configs/Roles";

const titles = {
    KEYS_MANAGEMENT: 'KeysManagement',
};

export const KeysManagement = [
    {
        icon: 'KeySvgIcon',
        component: 'KeysManagement',
        path: '/keys-management',
        title: titles.KEYS_MANAGEMENT,
        key: 'KeysManagement',
        menu: 'Keys Management',
        parent: true,
        permission: [Roles.RESELLER]
    },
];